var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConvenienceFee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28655 10.1959L5.7148 19.3303C5.90886 19.8473 6.48535 20.1092 7.00241 19.9151L16.0637 16.5143C16.5808 16.3202 16.8426 15.7437 16.6485 15.2267L13.0419 5.61697C12.9487 5.36866 12.7607 5.16755 12.5192 5.05787L6.61504 2.37612C6.1122 2.14773 5.51941 2.37021 5.29101 2.87305L2.3123 9.431C2.20262 9.67248 2.19336 9.94763 2.28655 10.1959Z",
    fill: "#FF7A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41697 12.5518C8.52664 12.1354 8.95429 11.0807 8.56898 10.054C8.17951 9.01631 7.15109 8.47031 6.04142 8.88679C4.94253 9.29922 4.5273 10.387 4.91676 11.4247C5.30208 12.4514 6.31807 12.9643 7.41697 12.5518ZM8.95411 16.32L10.7909 7.23019L9.97208 7.5375L8.1461 16.6232L8.95411 16.32ZM12.85 15.0089C13.9489 14.5965 14.3831 13.5267 13.9978 12.5001C13.6084 11.4624 12.5692 10.9204 11.4703 11.3328C10.3714 11.7453 9.95615 12.8331 10.3456 13.8708C10.7309 14.8974 11.7511 15.4214 12.85 15.0089ZM7.0938 11.6908C6.60899 11.8727 6.10182 11.6349 5.88638 11.0608C5.65436 10.4426 5.88393 9.94085 6.36874 9.75889C6.86432 9.57289 7.35657 9.80376 7.58859 10.422C7.80403 10.996 7.58938 11.5048 7.0938 11.6908ZM12.5268 14.1479C12.0312 14.3339 11.539 14.103 11.3152 13.5069C11.0874 12.8997 11.302 12.3909 11.7976 12.2049C12.2932 12.0189 12.8003 12.2568 13.0282 12.864C13.2519 13.4601 13.0224 13.9619 12.5268 14.1479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvenienceFee);
export default __webpack_public_path__ + "static/media/ConvenienceFee.8cd282a2851a2e95418143fa497f963d.svg";
export { ForwardRef as ReactComponent };